/**
 * Refresco de sesión respecto al backend Byhours (hook Nitro → user-data).
 * La respuesta de GET `/api/_auth/session` debe ir sin caché (ver `routeRules` en `nuxt.config.ts`).
 */
export function useByhoursSessionRefresh() {
  const { fetch: fetchSession } = useUserSession()

  async function refreshUserSession(): Promise<void> {
    await fetchSession()
    await nextTick()
  }

  return {
    refreshUserSession
  }
}
